import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from './services/auth.interceptor';
import { CommonModule } from '@angular/common';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { RecaptchaModule } from 'ng-recaptcha-2';

import { provideOktaAuth, OKTA_CONFIG } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';
import { environment } from '../environments/environment';

import { providePrimeNG } from 'primeng/config';
import { Divider } from 'primeng/divider';
import { InputMask } from 'primeng/inputmask';
import { InputText } from 'primeng/inputtext';
import { MessageService, PrimeTemplate } from 'primeng/api';
import { Password } from 'primeng/password';
import { Toast } from 'primeng/toast';
import { Menubar } from 'primeng/menubar';
import { Card } from 'primeng/card';
import { Button, ButtonModule } from 'primeng/button';
import { SelectButton } from 'primeng/selectbutton';
import { Select } from 'primeng/select';
import { FloatLabel } from 'primeng/floatlabel';
import { PrimeNgBaseTheme } from './primeNg-base-theme';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { AuthService } from './services/auth.service';

import { LoginComponent } from './login/login.component';
import { RegisterComponent } from './register/register.component';
import { UnimplementedRouteComponent } from '../app/unimplemented-route/unimplemented-route.component';
import { ResetPasswordComponent } from './login/reset-password.component';
import { HeaderNavComponent } from './header-nav/header-nav.component';
import { UtilityService } from './services/utility.service';
import { ExpiringSessionCountdownComponent } from './shared/modal/expiring-session-countdown/expiring-session-countdown.component';
import { NotificationComponent } from './shared/modal/notification/notification.component';
import { SharedService } from './shared/shared.service';
import { DialogService } from 'primeng/dynamicdialog';

// Okta configuration factory
function createOktaConfig() {
  return {
    oktaAuth: new OktaAuth({
      issuer: `https://${environment.okta.domain}/oauth2/default`,
      clientId: environment.okta.clientId,
      redirectUri: environment.okta.redirectUri,
      scopes: environment.okta.scopes,
      pkce: true,
      tokenManager: {
        autoRenew: true,
        storage: 'localStorage'
      }
    })
  };
}

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    RegisterComponent,
    ResetPasswordComponent,
    UnimplementedRouteComponent,
    HeaderNavComponent,
    ExpiringSessionCountdownComponent,
    NotificationComponent,
  ],
  imports: [
    AppRoutingModule,
    BrowserAnimationsModule,
    BrowserModule,
    CommonModule,
    Divider,
    HttpClientModule,
    InputMask,
    InputText,
    Card,
    ButtonModule,
    Menubar,
    Password,
    PrimeTemplate,
    ReactiveFormsModule,
    RecaptchaModule,
    Toast,
    SelectButton,
    Select,
    FloatLabel,
  ],
  providers: [
    AuthService,
    SharedService,
    DialogService,
    MessageService,
    { provide: OKTA_CONFIG, useFactory: createOktaConfig },
    provideOktaAuth(),
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: PrimeNgBaseTheme,
      },
    }),
    {
      provide: APP_INITIALIZER,
      multi: true,
      deps: [UtilityService],
      useFactory: (utilityService: UtilityService) => {
        return () => {
          return utilityService.loadSiteConfigurations();
        };
      },
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
